import { Checkbox, Grid, InputAdornment, Stack, TextField, Typography } from '@mui/material';
import React, { useContext } from 'react';
import { IoSearch } from 'react-icons/io5';
import { LanguageContext } from '../../../../../../../../../../../libs/Context';
import ProfilePic from '../../../../../../../../../../../components/Common/ProfilePic';
const ManageContentSlider = () =>
{
	const { language } = useContext(LanguageContext);

	const users = [
		{ id: 1, name: 'Ram Kumar', createdBy: true, img: 'https://via.placeholder.com/40', edit: true, view: true },
		{ id: 2, name: 'Rohit Varma Ram Kumar varma', createdBy: false, img: 'https://via.placeholder.com/40', edit: true, view: true },
		{ id: 3, name: 'Praveen Kumar', createdBy: false, img: 'https://via.placeholder.com/40', edit: true, view: true },
		{ id: 4, name: 'Vamsi Reddy', createdBy: false, img: 'https://via.placeholder.com/40', edit: true, view: true }
	];

	return (
		<Grid container>
			<TextField
				fullWidth
				size='small'
				placeholder={language?.search}
				sx={{
					backgroundColor            : '#F4F4F4',
					borderRadius               : '4px',
					'& .MuiOutlinedInput-root' : {
						border       : 'none',
						'& fieldset' : {
							border : 'none'
						},
						'&:hover fieldset' : {
							border : 'none'
						},
						'&.Mui-focused fieldset' : {
							border : 'none'
						}
					},
					'& .MuiInputBase-root' : {
						boxShadow : 'none'
					}
				}}
				InputProps={{
					startAdornment : (
						<InputAdornment position='start'>
							<IoSearch />
						</InputAdornment>
					)
				}}
			/>
			<Grid container py={2}>
				{/* Header Row */}
				<Grid item xs={8} display={'flex'} alignItems={'end'}>
					<Typography>{language?.name}</Typography>
				</Grid>
				<Grid item xs={2} alignItems={'center'}>
					<Checkbox checked/>
					<Typography pl={'6px'}>{language?.edit}</Typography>
				</Grid>
				<Grid item xs={2} alignItems={'center'}>
					<Checkbox checked/>
					<Typography pl={'6px'}>{language?.view}</Typography>
				</Grid>

				{/* User Rows */}
				{users.map((user) => (
					<Grid container key={user.id} pt={1} alignItems='center'>
						{/* Name with Avatar */}
						<Grid item container xs={8} flexWrap={'nowrap'} display='flex' alignItems='center'>
							<Grid item display={'flex'}>
								<ProfilePic
									imagePath={'https://media.istockphoto.com/id/1399565382/photo/young-happy-mixed-race-businessman-standing-with-his-arms-crossed-working-alone-in-an-office.jpg?s=612x612&w=0&k=20&c=buXwOYjA_tjt2O3-kcSKqkTp2lxKWJJ_Ttx2PhYe3VM='}
									defaultImg='/images/icons/defaultUser.svg'
									alt='profile'
									className='brdrRadius50 imgAvatarXXS'
								/>
							</Grid>
							<Grid item minWidth={0} pl={1}>
								<Stack direction={'column'}>
									<Typography overflow={'hidden'} textTransform={'capitalize'} textOverflow={'ellipsis'} whiteSpace={'nowrap'}>{user.name}</Typography>
									{user.createdBy && <Typography fontSize={'10px'} fontWeight={'var(--font500)'} color={'#606162'}>{language?.createdBy}</Typography>}

								</Stack>
							</Grid>
						</Grid>

						{/* Edit Checkbox */}
						<Grid item xs={2} alignItems={'center'}>
							<Checkbox checked={user.edit} disabled={user.createdBy}/>
						</Grid>

						{/* View Checkbox */}
						<Grid item xs={2} alignItems={'center'}>
							<Checkbox checked={user.view} disabled={user.createdBy}/>
						</Grid>
					</Grid>
				))}
			</Grid>
		</Grid>
	);
};

export default ManageContentSlider;